import Vue from "vue";
import Router from "vue-router";
// import routes from './data/routes.json';
import store from "./store";
import auth from "./apis/auth.js";
import token from "./libs/boogr-token";

Vue.use(Router);

const routes = [
  {
    name: "page",
    path: "/page",
    component: require("./containers/page.vue").default,
  },
  {
    name: "page.register",
    path: "register",
    component: require("./views/register.vue").default,
  },
  {
    name: "page.login",
    path: "login",
    component: require("./views/login.vue").default,
  },

  {
    name: "app",
    path: "/",
    component: require("./containers/mc-modul.vue").default,
    redirect: "/modules",
    secured: true,
  },
  {
    name: "app.modules",
    path: "modules",
    component: require("./views/modules.vue").default,
    text: "Modules",
  },
  {
    name: "app.approval",
    path: "approval-list",
    component: require("./views/approval.vue").default,
    text: "Approval List",
  },
  {
    name: "app.approvalfrm",
    path: "approval-form/:key?",
    component: require("./views/approvalfrm.vue").default,
    text: "Approval Form",
  },
  {
    name: "app.profile",
    path: "profile",
    component: require("./views/profile.vue").default,
    text: "Profile",
  },
  {
    name: "app.requisition",
    path: "requisition",
    component: require("./views/requisition.vue").default,
    text: "Self Service Requisition",
  },
  {
    name: "app.requisitionfrm",
    path: "requisition-form",
    component: require("./views/requisitionfrm.vue").default,
    text: "Self Service Requisition Form",
  },
  {
    name: "app.requisitionview",
    path: "requisition-view",
    component: require("./views/requisitionview.vue").default,
    text: "Requisition View",
  },
  {
    name: "app.circulationdocument",
    path: "serah-terima-dokumen",
    component: require("./views/circulationdoc.vue").default,
    text: "Circulation Document",
  },
  {
    name: "app.expensesnote",
    path: "catatan-pemakaian-dana",
    component: require("./views/expensesnote.vue").default,
    text: "My Expenses Book",
  },
  {
    name: "app.prview",
    path: "view_purchase-request",
    component: require("./views/pr_view.vue").default,
    text: "Purchase Request View",
  },
  {
    name: "app.unauthorize",
    path: "unauthorize",
    component: require("./views/unauthorize.vue").default,
  },

  {
    name: "admin",
    path: "/admin",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "admin/home",
    text: "Admin",
  },
  {
    name: "admin.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "admin.menu",
    path: "menu/:modulname?/:username?",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/menu.vue"),
    text: "Menu",
    secured: true,
  },
  {
    name: "admin.backupdb",
    path: "backupdb",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/backup.vue"),
    text: "Backup Database",
    secured: true,
  },
  {
    name: "admin.company",
    path: "company-profile",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "./views/admin/companyprofile.vue"
      ),
    text: "Company Profile",
    secured: true,
  },
  {
    name: "admin.companyadd",
    path: "company-add",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/companyadd.vue"),
    text: "Add New Company Profile",
    secured: true,
  },
  {
    name: "admin.notification",
    path: "notification-config",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/notification.vue"),
    text: "Notification",
    secured: true,
  },
  {
    name: "admin.user",
    path: "user",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/usernopwd.vue"),
    text: "Manage User",
    secured: true,
  },
  {
    name: "admin.usercompany",
    path: "user-company",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/companyuser.vue"),
    text: "Company handle by User",
    secured: true,
  },
  {
    name: "admin.usermodul",
    path: "user-modul",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/usermodul.vue"),
    text: "User per Modul",
    secured: true,
  },
  {
    name: "admin.userroles",
    path: "user-roles",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/user-roles.vue"),
    text: "User Roles",
    secured: true,
  },
  {
    name: "admin.userresetlog",
    path: "password-reset-log",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "./views/admin/user-reset-log.vue"
      ),
    text: "Password Reset Log",
    secured: true,
  },
  {
    name: "admin.workflow",
    path: "workflow-config",
    component: () =>
      import(/* webpackChunkName: "admin" */ "./views/admin/workflow.vue"),
    text: "Manage Workflow",
    secured: true,
  },
  {
    name: "admin.wffunctionalapproval",
    path: "workflow-functional-approval",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "./views/admin/workflowfunctionalapproval.vue"
      ),
    text: "Manage Workflow functional approval",
    secured: true,
  },
  {
    name: "admin.wfactionhistory",
    path: "workflow-action-history",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "./views/admin/workflowactionhist.vue"
      ),
    text: "Workflow Action History",
    secured: true,
  },

  {
    name: "accounting",
    path: "/accounting",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "accounting/home",
    text: "Accounting",
  },
  {
    name: "accounting.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  //Master
  {
    name: "accounting.dimval",
    path: "dimval",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/dimsample.vue"
      ),
    text: "Dimension Value",
    secured: true,
  },
  {
    name: "accounting.mstrprojecttype",
    path: "project-job-type",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/budget/mstrprojecttype.vue"
      ),
  },
  {
    name: "accounting.mstrproject",
    path: "project",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/budget/mstrproject.vue"
      ),
  },
  {
    name: "accounting.bslayout",
    path: "bs-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/bs_layout_visible.vue"
      ),
    secured: true,
    text: "Define Balance Sheet Layout Lines",
  },
  {
    name: "accounting.cashflwindifmt",
    path: "cashflow-indirect-layout",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/cashflow_indi_layout.vue"
      ),
    secured: true,
    text: "Define Cash Flow Layout Lines",
  },
  {
    name: "accounting.fplayout",
    path: "fp-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/fp_layout.vue"
      ),
    secured: true,
    text: "Define Financial Position Layout Lines",
  },
  {
    name: "accounting.incomestatlayout",
    path: "is-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/pnl_layout.vue"
      ),
    secured: true,
    text: "Define Income Statement Layout Lines",
  },
  {
    name: "accounting.coa",
    path: "coa",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/coa.vue"),
    text: "Chart of Account",
    secured: true,
  },
  {
    name: "accounting.company",
    path: "company-profile",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/admin/company.vue"),
    text: "Company Profile",
    secured: true,
  },
  {
    name: "accounting.dimsetup",
    path: "dimsetup",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/dimsetup.vue"
      ),
    text: "Dimension Setup",
    secured: true,
  },
  {
    name: "accounting.accruedtmp",
    path: "accrued-template",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/accruedtmp.vue"
      ),
    text: "Accrued Template - Reguler Cost",
    secured: true,
  },
  {
    name: "accounting.groupacc",
    path: "group-account",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/groupacc.vue"
      ),
    secured: true,
    text: "Group Acccount",
  },
  {
    name: "accounting.amortization",
    path: "amortization-recouring",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/amortization.vue"
      ),
    text: "Amortization Template/Schedule",
    secured: true,
  },
  {
    name: "accounting.amortizfrm",
    path: "amortization-form",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/amortizfrm.vue"
      ),
    text: "Amortization/Recouring Form",
    secured: true,
  },
  //Transaction
  {
    name: "accounting.accruedtrx",
    path: "jurnal-accrue",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/accruedtrx.vue"
      ),
    text: "Accrued Journal- Reguler Cost",
    secured: true,
  },
  {
    name: "accounting.book",
    path: "book",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/book.vue"
      ),
    text: "Jurnal Efective",
    secured: true,
  },
  {
    name: "accounting.bookinproblem",
    path: "book-in-problem",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/bookinproblem.vue"
      ),
    text: "Jurnal in problem",
    secured: true,
  },
  {
    name: "accounting.bookfrm",
    path: "jurnal-form/:nomor?/:tanggal?/",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/bookfrm.vue"
      ),
    text: "Journal Voucher Form",
    secured: true,
  },
  {
    name: "accounting.jurnal",
    path: "jurnal",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/jurnal.vue"
      ),
    text: "Jurnal Efective",
    secured: true,
  },
  {
    name: "accounting.jurnalfrm",
    path: "jurnal-edit",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/jurnalfrm.vue"
      ),
    text: "Journal Voucher Form",
    secured: true,
  },
  {
    name: "accounting.exchrate",
    path: "exchange-rate",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/exchrate.vue"
      ),
    text: "Exchange Rate",
    secured: true,
  },
  {
    name: "accounting.periodeclose",
    path: "closing-periode",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/periodeclose.vue"
      ),
    text: "Closing Periode",
    secured: true,
  },
  {
    name: "accounting.pip",
    path: "pip",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/pip.vue"),
    text: "Project/Work In Progress",
    secured: true,
  },
  {
    name: "accounting.pip-reclass",
    path: "pip-reclass",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/pip-reklass.vue"
      ),
    text: "Reclasss - Project/Work In Progress",
    secured: true,
  },
  {
    name: "accounting.loan",
    path: "pinjaman-karyawan",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/payroll/loan.vue"),
    secured: true,
    text: "Daftar - Pinjaman Karyawan",
  },
  {
    name: "accounting.loanfrm",
    path: "pinjaman-karyawan-form",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/payroll/loanfrm.vue"
      ),
    secured: true,
    text: "Form - Pinjaman Karyawan",
  },
  {
    name: "accounting.loanaraging",
    path: "pinjaman-saldo-piutang",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/payroll/loan_saldo.vue"
      ),
    secured: true,
    text: "Saldo Piutang - Pinjaman Karyawan",
  },
  {
    name: "accounting.loaninstallment",
    path: "pinjaman-jadwal-angsuran",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/payroll/loan_cicilan.vue"
      ),
    secured: true,
    text: "Jadwal Angsuran - Pinjaman Karyawan",
  },
  //Report
  // { name: "accounting.bs", path: "balance-sheet", component: () => import(/* webpackChunkName: "accounting" */ './views/accounting/bs.vue'), secured: true, text: "Balance Sheet" },
  {
    name: "accounting.bs",
    path: "balance-sheet",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/bs_visible.vue"
      ),
    secured: true,
    text: "Balance Sheet",
  },
  {
    name: "accounting.cashflow",
    path: "cashflow-indirect",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/cashflow_indirect.vue"
      ),
    secured: true,
    text: "Cash Flow",
  },
  {
    name: "accounting.fp",
    path: "financial-position",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/fp.vue"),
    secured: true,
    text: "Financial Position",
  },
  {
    name: "accounting.fp12m",
    path: "financial-position-12months",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/fp12m.vue"
      ),
    secured: true,
    text: "Financial Position",
  },
  {
    name: "accounting.gl",
    path: "general-ledger/:kodeaw?/:tgl1?/:tgl2?",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/gl.vue"),
    secured: true,
    text: "General Ledger",
  },
  {
    name: "accounting.glpnldim",
    path: "dim-detailtrx/:DimCol?/:DimVal?/:kodeaw?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/gl-pnldim.vue"
      ),
    secured: true,
    text: "Detail Transaction by Dimension",
  },
  {
    name: "accounting.incomestat",
    path: "income-statement",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/pnl.vue"),
    secured: true,
    text: "Income Statement (Profit/(Loss))",
  },
  {
    name: "accounting.pnldim1",
    path: "pnl-dimension",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/pnldim1.vue"
      ),
    secured: true,
    text: "Profit/(Loss) per Dimension",
  },
  {
    name: "accounting.pnldim10",
    path: "pnl-dimension-all",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/pnldim10.vue"
      ),
    secured: true,
    text: "Profit/(Loss) Dimension All(Best 10)",
  },
  {
    name: "accounting.pnldimanalys",
    path: "pnl-dimension-analysis",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/pnldimanalys.vue"
      ),
    secured: true,
    text: "Profit/(Loss) Analysis By Dimension",
  },
  {
    name: "accounting.tb",
    path: "trial-balance/:kodeaw?/:tgl1?/:tgl2?",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/tb.vue"),
    secured: true,
    text: "Trial Balance",
  },
  //Setting
  // { name: "accounting.bslayout", path: "bs-layout-lines", component: () => import(/* webpackChunkName: "accounting" */ './views/accounting/bs_layout.vue'), secured: true, text: "Define Balance Sheet Layout Lines" },
  {
    name: "accounting.periodeset",
    path: "set-periode",
    component: () =>
      import(
        /* webpackChunkName: "accounting" */ "./views/accounting/periodeset.vue"
      ),
    text: "Set Current Periode",
    secured: true,
  },

  {
    name: "advance",
    path: "/advance",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "advance/home",
    text: "Cash Advance Management",
  },
  {
    name: "advance.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  // Master File
  {
    name: "advance.expgroup",
    path: "exp-reimburs-group",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/expgroup.vue"),
    secured: true,
    text: "Expense Reimbursment Group Posting",
  },
  {
    name: "advance.advgroup",
    path: "adv-group",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/advgroup.vue"),
    secured: true,
    text: "Cash Advance Group Posting",
  },
  {
    name: "advance.advgroupuser",
    path: "adv-group-user",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advgroupuser.vue"
      ),
    secured: true,
    text: "Cash Advance Group Posting",
  },
  {
    name: "advance.crew",
    path: "master-employee",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/crew.vue"),
    secured: true,
    text: "Accrued Cash Advance",
  },
  {
    name: "advance.crewfrm",
    path: "form-employee",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/crewfrm.vue"),
    secured: true,
    text: "Accrued Cash Advance",
  },
  {
    name: "advance.crewdept",
    path: "master-department",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/department.vue"
      ),
    secured: true,
    text: "Accrued Cash Advance",
  },
  {
    name: "advance.crewpost",
    path: "master-job-position",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/pangkat.vue"),
    secured: true,
    text: "Summary/Aging Cash Advance",
  },
  {
    name: "advance.crewgroup",
    path: "master-job-group",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/golongan.vue"),
    secured: true,
    text: "Cash Advance Group Posting",
  },
  //Transaction
  {
    name: "advance.myrequest",
    path: "my-request",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/crew-advrequest.vue"
      ),
    secured: true,
    text: "My Cash Advance Request",
  },
  {
    name: "advance.mysettlement",
    path: "my-settlement",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/crew-advsettle.vue"
      ),
    secured: true,
    text: "My Cash Advance Settlement",
  },
  {
    name: "advance.myexpreimburs",
    path: "my-exp-reimburs",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/crew-expreimburs.vue"
      ),
    secured: true,
    text: "My Expense Reimburs",
  },
  {
    name: "advance.expreimburs",
    path: "exp-reimburs-list",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/expreimburs.vue"
      ),
    secured: true,
    text: "Expense Reimbursment",
  },
  {
    name: "advance.expreimbursfrm",
    path: "exp-reimburs-form",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/expreimbursfrm.vue"
      ),
    secured: true,
    text: "Expense Reimbursment Form",
  },
  {
    name: "advance.expreimbursAdj",
    path: "exp-reimburs-adj",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/expreimburs-adjust.vue"
      ),
    secured: true,
    text: "Expense Reimbursment Adjusment ",
  },
  {
    name: "advance.expreimbursAdjfrm",
    path: "exp-reimburs-adj-form",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/expreimburs-adjustfrm.vue"
      ),
    secured: true,
    text: "Expense Reimbursment Adjusment Form",
  },
  {
    name: "advance.advaccru",
    path: "accrued-advance",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/advaccru.vue"),
    secured: true,
    text: "Accrued Cash Advance",
  },
  {
    name: "advance.requestlist",
    path: "request-list",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advrequest.vue"
      ),
    secured: true,
    text: "Cash Advance Request List",
  },
  {
    name: "advance.requestfrm",
    path: "request-form",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advrequestfrm.vue"
      ),
    secured: true,
    text: "Cash Advance Request Form",
  },
  {
    name: "advance.settlelist",
    path: "settlement-list",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/settlelist.vue"
      ),
    secured: true,
    text: "Cash Advance Settlement",
  },
  {
    name: "advance.settlefrm",
    path: "settlement-form",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/settlefrm.vue"),
    secured: true,
    text: "Cash Advance Settlement Form",
  },
  //Report
  {
    name: "advance.advaging",
    path: "adv-aging",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/advaging.vue"),
    secured: true,
    text: "Aging Cash Advance",
  },
  {
    name: "advance.advsummary",
    path: "adv-summary",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advsummary.vue"
      ),
    secured: true,
    text: "Summary Cash Advance",
  },
  {
    name: "advance.advhistory",
    path: "adv-trx-history",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advtrxhist.vue"
      ),
    secured: true,
    text: "Cash Advance Transaction History",
  },
  {
    name: "advance.advoutstand",
    path: "outstanding-un-settle",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/advoutstand.vue"
      ),
    secured: true,
    text: "Cash Advance Transaction History",
  },
  {
    name: "advance.myhistory",
    path: "my-adv-trx-history",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/crew-advtrxhist.vue"
      ),
    secured: true,
    text: "Cash Advance Transaction History",
  },
  {
    name: "advance.myoutstand",
    path: "my-outstanding-un-settle",
    component: () =>
      import(
        /* webpackChunkName: "advance" */ "./views/advance/crew-advoutstand.vue"
      ),
    secured: true,
    text: "Cash Advance Transaction History",
  },
  {
    name: "advance.rekoncadb",
    path: "reconcile-cash-adv-db",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/rekoncadb.vue"),
    secured: true,
    text: "Reconcile Cash Advance Payment",
  },
  {
    name: "advance.rekoncakr",
    path: "reconcile-cash-adv-cr",
    component: () =>
      import(/* webpackChunkName: "advance" */ "./views/advance/rekoncakr.vue"),
    secured: true,
    text: "Reconcile Cash Advance Settlememt",
  },
  {
    name: "advance.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "receivable" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  {
    name: "advance.wfactionhistory",
    path: "workflow-action-history",
    component: () =>
      import(
        /* webpackChunkName: "admin" */ "./views/admin/workflowactionhist.vue"
      ),
    text: "Workflow Action History",
    secured: true,
  },

  {
    name: "budget",
    path: "/budget",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "budget/home",
    text: "Budget Control",
  },
  {
    name: "budget.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "budget.dimval",
    path: "dimension-value",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/accounting/dimsample.vue"
      ),
    text: "Dimension Value",
    secured: true,
  },
  {
    name: "budget.mstrprojecttype",
    path: "project-job-type",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrprojecttype.vue"
      ),
  },
  {
    name: "budget.mstrproject",
    path: "project",
    component: () =>
      import(/* webpackChunkName: "budget" */ "./views/budget/mstrproject.vue"),
    secured: true,
  },
  {
    name: "budget.annualbudgetytd",
    path: "ytd-budget-realization",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetytdv2.vue"
      ),
    secured: true,
  },
  {
    name: "budget.annualbudgetfull",
    path: "budget-realization",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetfullv2.vue"
      ),
    secured: true,
  },
  {
    name: "budget.annualbudgetprogress",
    path: "annual-budget-progress/:layout?/:departkd?/:departemen?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetfull.vue"
      ),
    secured: true,
  },
  {
    name: "budget.layoutbudget",
    path: "set-layout-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetlayout.vue"
      ),
    secured: true,
  },
  {
    name: "budget.layoutbudgetprod",
    path: "set-layout-budget-production",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrbudgetlayout.vue"
      ),
    secured: true,
  },
  {
    name: "budget.costingitem",
    path: "costing-items",
    component: () =>
      import(/* webpackChunkName: "budget" */ "./views/budget/costingitem.vue"),
    secured: true,
  },
  //budget planning
  {
    name: "budget.annualbudget",
    path: "annual-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudget.vue"
      ),
    secured: true,
  },
  {
    name: "budget.annualbudgetcopy",
    path: "annual-budget-copy",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetcopy.vue"
      ),
    secured: true,
  },
  {
    name: "budget.annualbudgetfrm",
    path: "annual-budget-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/annualbudgetfrm.vue"
      ),
    secured: true,
  },
  {
    name: "budget.mymstrbudget",
    path: "my-production-budget",
    component: () =>
      import(/* webpackChunkName: "budget" */ "./views/budget/mstrbudget-my.vue"),
    secured: true,
  },
  {
    name: "budget.mstrbudget",
    path: "production-budget",
    component: () =>
      import(/* webpackChunkName: "budget" */ "./views/budget/mstrbudget.vue"),
    secured: true,
  },
  {
    name: "budget.mstrbudgetfrm",
    path: "production-budget-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrbudgetfrm.vue"
      ),
    secured: true,
  },
  {
    name: "budget.myinternbudget",
    path: "my-internal-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudget-my.vue"
      ),
    secured: true,
  },
  {
    name: "budget.internbudget",
    path: "internal-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudget.vue"
      ),
    secured: true,
  },
  {
    name: "budget.internbudgetfrm",
    path: "internal-budget-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudgetfrm.vue"
      ),
    secured: true,
  },
  {
    name: "budget.myadditionbudget",
    path: "my-additional-master-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrbudgetaddition-my.vue"
      ),
    secured: true,
  },
  {
    name: "budget.additionbudget",
    path: "additional-master-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrbudgetaddition.vue"
      ),
  },
  {
    name: "budget.additionbudgetfrm",
    path: "additional-master-budget-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/mstrbudgetadditionfrm.vue"
      ),
    secured: true,
  },
  {
    name: "budget.myaddinternbudget",
    path: "my-additional-internal-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudgetadd-my.vue"
      ),
    secured: true,
  },
  {
    name: "budget.addinternbudget",
    path: "additional-internal-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudgetadd.vue"
      ),
    secured: true,
  },
  {
    name: "budget.addinternbudgetfrm",
    path: "additional-internal-budget-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/internbudgetaddfrm.vue"
      ),
    secured: true,
  },
  {
    name: "budget.glbook",
    path: "gl-journal",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/bookaccounting.vue"
      ),
    secured: true,
  },
  {
    name: "budget.glbookreklass",
    path: "gl-journal-reclass",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/bukureklasbc.vue"
      ),
    secured: true,
  },
  {
    name: "budget.glbookreklassfrm",
    path: "gl-journal-reclass-form",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/bukureklasbcfrm.vue"
      ),
    secured: true,
  },
  //report
  {
    name: "budget.ledger",
    path: "ledger/:kodeaw?/:tgl1?/:tgl2?/:namaacc?/:departkd?/:departnm?/:opsidept?/:dimcol?",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/budget-ledger.vue"
      ),
    secured: false,
    text: "General Ledger",
  },
  {
    name: "budget.fpbudget",
    path: "account-position",
    component: () =>
      import(/* webpackChunkName: "budget" */ "./views/budget/budget-fp.vue"),
    secured: true,
    text: "General Ledger",
  },
  {
    name: "budget.progressproject",
    path: "progress-project-budget",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/progressbudget_project.vue"
      ),
  },
  {
    name: "budget.progressmstrbudget",
    path: "progress-master-budget/:pjxhdrkey?",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/progressmstrbudget.vue"
      ),
  },
  {
    name: "budget.progressinterbudget",
    path: "progress-internal-budget/:ibudghdkey?",
    component: () =>
      import(
        /* webpackChunkName: "budget" */ "./views/budget/progressinterbudget.vue"
      ),
  },
  {
    name: "budget.gl",
    path: "acc-general-ledger",
    component: () =>
      import(/* webpackChunkName: "accounting" */ "./views/accounting/gl.vue"),
    secured: true,
    text: "General Ledger",
  },

  {
    name: "consolidation",
    path: "/consolidation",
    component: () =>
      import(
        /* webpackChunkName: "submodul" */ "./containers/consolidation.vue"
      ),
    redirect: "consolidation/home",
    text: "Consolidation",
  },
  {
    name: "consolidation.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "consolidation.coa",
    path: "coa",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/coa.vue"
      ),
    text: "Chart of Account",
    secured: true,
  },
  {
    name: "consolidation.coamapping",
    path: "coa-maping",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/coamaping.vue"
      ),
    text: "Maping Chart of Account",
    secured: true,
  },
  {
    name: "consolidation.unitbisnis",
    path: "unit-business",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/companyconsol.vue"
      ),
    text: "Unit Business Company",
    secured: true,
  },
  {
    name: "consolidation.tbunitbisnis",
    path: "tb-unit-bisnis",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/tbunitbisnis.vue"
      ),
    text: "TB Unit Business Company",
    secured: true,
  },
  {
    name: "consolidation.kertaskerja",
    path: "consolidation-worksheet",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/kertaskerja.vue"
      ),
    text: "Consolidation Worksheet",
    secured: true,
  },
  {
    name: "consolidation.eliminasitemplate",
    path: "template-eliminasi",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/jv_eliminasi_template.vue"
      ),
    text: "Jurnal Eliminasi",
    secured: true,
  },
  {
    name: "consolidation.jurnal",
    path: "jurnal",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/jv_eliminasi.vue"
      ),
    text: "Jurnal Eliminasi",
    secured: true,
  },
  {
    name: "consolidation.jurnalfrm",
    path: "jurnal-form",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/jv_eliminasifrm.vue"
      ),
    text: "Journal Eliminasi Form",
    secured: true,
  },
  {
    name: "consolidation.groupacc",
    path: "group-account",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/groupacc.vue"
      ),
    secured: true,
    text: "Group Acccount",
  },
  {
    name: "consolidation.periodeclose",
    path: "closing-periode",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/periodeclose.vue"
      ),
    text: "Closing Periode",
    secured: true,
  },
  {
    name: "consolidation.periodeset",
    path: "set-periode",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/periodeset.vue"
      ),
    text: "Set Current Periode",
    secured: true,
  },
  //report
  {
    name: "consolidation.bs",
    path: "balance-sheet",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/bs.vue"
      ),
    secured: true,
    text: "Balance Sheet",
  },
  {
    name: "consolidation.bslayout",
    path: "bs-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/bs_layout.vue"
      ),
    secured: true,
    text: "Define Balance Sheet Layout Lines",
  },
  {
    name: "consolidation.cashflow",
    path: "cashflow-indirect",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/cashflow_indirect.vue"
      ),
    secured: true,
    text: "Cash Flow",
  },
  {
    name: "consolidation.cashflwindifmt",
    path: "cashflow-indirect-layout",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/cashflow_indi_layout.vue"
      ),
    secured: true,
    text: "Define Cash Flow Layout Lines",
  },
  {
    name: "consolidation.fp",
    path: "financial-position",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/fp.vue"
      ),
    secured: true,
    text: "Financial Position",
  },
  {
    name: "consolidation.fp12m",
    path: "financial-position-12months",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/fp12m.vue"
      ),
    secured: true,
    text: "Financial Position",
  },
  {
    name: "consolidation.fplayout",
    path: "fp-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/fp_layout.vue"
      ),
    secured: true,
    text: "Define Financial Position Layout Lines",
  },
  {
    name: "consolidation.incomestat",
    path: "income-statement",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/pnl.vue"
      ),
    secured: true,
    text: "Income Statement (Profit/(Loss))",
  },
  {
    name: "consolidation.incomestatlayout",
    path: "is-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "consolidation" */ "./views/consolidation/pnl_layout.vue"
      ),
    secured: true,
    text: "Define Income Statement Layout Lines",
  },

  {
    name: "fixedasset",
    path: "/fixedasset",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "fixedasset/home",
    text: "Fixed Asset",
  },
  {
    name: "fixedasset.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "fixedasset.categoryreclass",
    path: "category-reclass",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/asset_reclass.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.depreciate",
    path: "depreciation",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetdepr_bycateg.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.depreciationadjust",
    path: "depreciation-adjustment",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetdepr_adjust.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.disposal",
    path: "disposal",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/asset_disposal.vue"
      ),
    secured: true,
    text: "List of Fixed Asset Disposed",
  },
  {
    name: "fixedasset.form",
    path: "form-fixed-asset",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetfrm.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.formga",
    path: "form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetfrmga.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.groupfa",
    path: "category-fixed-asset",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/asset_category.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.list",
    path: "list-fixed-asset",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetlist.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.listga",
    path: "list",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetlistga.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.lokasi",
    path: "location-fixed-asset",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/lokasifa.vue"
      ),
    secured: true,
    text: "List of Fixed Asset",
  },
  {
    name: "fixedasset.mutation",
    path: "mutation",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetmutation.vue"
      ),
    secured: true,
    text: "List of Mutaion Fixed Asset",
  },
  {
    name: "fixedasset.mutationfrm",
    path: "mutation-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/assetmutationfrm.vue"
      ),
    secured: true,
    text: "Fixed Asset Mutaion Form",
  },
  {
    name: "fixedasset.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "fixedasset" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  {
    name: "fixedasset.invlabel",
    path: "inventory-labeled",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/invlabel.vue"
      ),
    secured: true,
    text: "List of Mutaion Fixed Asset",
  },
  {
    name: "fixedasset.invlabelfrm",
    path: "inventory-labeled-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/invlabelfrm.vue"
      ),
    secured: true,
    text: "Fixed Asset Mutaion Form",
  },

  {
    name: "fixedasset.opname",
    path: "audit-opname",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/opname.vue"
      ),
    secured: true,
    text: "Audit/Opname",
  },
  {
    name: "fixedasset.opnamefrm",
    path: "audit-opname-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/opnamefrm.vue"
      ),
    secured: true,
    text: "Audit Opname Form",
  },
  {
    name: "fixedasset.rekonfadb",
    path: "reconcile-debit",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/rekonfadb.vue"
      ),
    secured: true,
    text: "Reconcile AP Settlements",
  },
  {
    name: "fixedasset.rekonfacr",
    path: "reconcile-credit",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/rekonfakr.vue"
      ),
    secured: true,
    text: "Reconcile Account Receivable",
  },
  //MAINTENANCE
  {
    name: "fixedasset.maintmanual",
    path: "maintenance-manual",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenmanual.vue"
      ),
    secured: true,
    text: "Maintenance Manual",
  },
  {
    name: "fixedasset.maintmanualfrm",
    path: "maintenance-manual-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenmanualfrm.vue"
      ),
    secured: true,
    text: "Maintenance Manual Form",
  },
  {
    name: "fixedasset.maintassetmm",
    path: "maintenance-asset",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenasset.vue"
      ),
    secured: true,
    text: "Asset Maintenance Book",
  },
  {
    name: "fixedasset.maintassetmmfrm",
    path: "maintenance-asset-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenassetfrm.vue"
      ),
    secured: true,
    text: "Asset Maintenance Book Form",
  },
  {
    name: "fixedasset.maintworkorder",
    path: "maintenance-workorder",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenspk.vue"
      ),
    secured: true,
    text: "Maintenance Workorder",
  },
  {
    name: "fixedasset.maintworkorderfrm",
    path: "maintenance-workorder-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenspkfrm.vue"
      ),
    secured: true,
    text: "Maintenance Workorder Form",
  },
  {
    name: "fixedasset.maintopenschedul",
    path: "maintenance-requisition-schedule",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenrequisition.vue"
      ),
    secured: true,
    text: "Maintenance Requisition",
  },
  {
    name: "fixedasset.maintopenschedulfrm",
    path: "maintenance-requisition-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenrequisitionfrm.vue"
      ),
    secured: true,
    text: "Maintenance Requisition Form",
  },
  {
    name: "fixedasset.maintrecord",
    path: "maintenance-record",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenrecord.vue"
      ),
    secured: true,
    text: "Maintenance Workorder",
  },
  {
    name: "fixedasset.maintrecordfrm",
    path: "maintenance-record-form",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenrecordfrm.vue"
      ),
    secured: true,
    text: "Maintenance Workorder Form",
  },
  //Report
  {
    name: "fixedasset.smryfa",
    path: "report-summary",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/rptfasaldo.vue"
      ),
    secured: true,
    text: "Report Summary Fixed Asset",
  },
  {
    name: "fixedasset.mainthistory",
    path: "maintenance-history",
    component: () =>
      import(
        /* webpackChunkName: "fixedasset" */ "./views/fixedasset/maintenhistory.vue"
      ),
    secured: true,
    text: "Maintenance Workorder",
  },

  {
    name: "logistic",
    path: "/logistic",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "logistic/home",
    text: "Logistic/Inventory",
  },
  {
    name: "logistic.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "logistic.item",
    path: "master-item-list",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/item.vue"
      ),
    secured: true,
    text: "List - Master Item",
  },
  {
    name: "logistic.itemfrm",
    path: "master-item-form",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemfrm.vue"
      ),
    secured: true,
    text: "Form - Master Item ",
  },
  {
    name: "logistic.itemcategory",
    path: "item-sub-category",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemcategory.vue"
      ),
    secured: true,
    text: "Post Sub Category - Master Item",
  },
  {
    name: "logistic.itemcategoryhead",
    path: "item-category",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemcategoryhead.vue"
      ),
    secured: true,
    text: "Post Category - Master Item",
  },
  {
    name: "logistic.itemcategoryuser",
    path: "mapping-itemcategory-user",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/itemcategoryheaduser.vue"
      ),
    secured: true,
    text: "Mapping Item Category vs User",
  },
  {
    name: "logistic.itemgroup",
    path: "item-grouping",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemgroup.vue"
      ),
    secured: true,
    text: "Item Grouping",
  },
  {
    name: "logistic.inventorycategory",
    path: "inventory-category",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/logistic/inv_category.vue"
      ),
    secured: true,
    text: "Inventory Group/Category",
  },
  {
    name: "logistic.store",
    path: "store-warehouse",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/store.vue"),
    secured: true,
    text: "Store / Warehouse",
  },
  //transaction
  {
    name: "logistic.mr",
    path: "material-request",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/mr_open.vue"),
    secured: true,
    text: "Material/Service Request List",
  },

  {
    name: "logistic.issued-reserved",
    path: "issued-reserved",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued-reserved.vue"
      ),
    secured: true,
    text: "Issued Reserved List",
  },
  {
    name: "logistic.issued-reserved-form",
    path: "issued-reserved-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued-reserved-form.vue"
      ),
    secured: true,
    text: "Form - Issued Reserved ",
  },

  {
    name: "logistic.pr",
    path: "purchase-request",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/pr.vue"),
    secured: true,
    text: "Purchase Request List",
  },
  {
    name: "logistic.prform",
    path: "purchase-request-form",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/pr_form.vue"),
    secured: true,
    text: "Purchase Request Form",
  },
  {
    name: "logistic.receiving",
    path: "receiving",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/procurement/receiving.vue"
      ),
    secured: true,
    text: "Receiving List",
  },
  {
    name: "logistic.receivingfrm",
    path: "receiving-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/procurement/receivingfrm.vue"
      ),
    secured: true,
    text: "Receiving Form",
  },

  // { name: "logistic.receivingposting", path: "po-receiving-posting", component: () => import(/* webpackChunkName: "logistic" */ './views/procurement/receivingapinvfrm.vue'), secured: false, text: "Receiving Posting" },
  {
    name: "logistic.receivingposting",
    path: "po-receiving-posting",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/procurement/receivingposting_partialconfirm.vue"
      ),
    secured: false,
    text: "Receiving Posting",
  },

  {
    name: "logistic.inv_in",
    path: "inventory-receipt",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/inv_in.vue"),
    secured: true,
    text: "Inventory IN(Receipt)",
  },
  {
    name: "logistic.inv_in_other",
    path: "inventory-receipt-other",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/inv_in_other.vue"
      ),
    secured: true,
    text: "Inventory IN from Non Purchase",
  },
  {
    name: "logistic.inv_in_media_dilepas",
    path: "inventory-media-display-dilepas",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/inv_in_media-dilepas.vue"
      ),
    secured: false,
    text: "Inventory IN from Media Display Replacment",
  },
  {
    name: "logistic.inv_in_purchase",
    path: "inventory-receipt-purchase",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/inv_in_purchase.vue"
      ),
    secured: true,
    text: "Inventory IN from Receiving Purchase Order",
  },
  {
    name: "logistic.inv_in_revision",
    path: "inventory-receipt-revision",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/inv_in_revisi.vue"
      ),
    secured: true,
    text: "Inventory Receipt Revision",
  },
  {
    name: "logistic.item_list",
    path: "item-list",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/itemcatalog.vue"
      ),
    secured: false,
    text: "Item List",
  },
  {
    name: "logistic.issued",
    path: "issued-list",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/issued.vue"),
    secured: true,
    text: "Inventory Issued List",
  },
  {
    name: "logistic.issuedform",
    path: "issued-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued_form.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },

  {
    name: "logistic.transferin_invunit",
    path: "transferin_invunit-list",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferin_invunit.vue"
      ),
    secured: true,
    text: "Transfer IN Inventory Unit List",
  },
  {
    name: "logistic.transferin_invunitform",
    path: "transferin_invunit-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferin_invunit_form.vue"
      ),
    secured: true,
    text: "transfer IN Inventory Unit Form",
  },

  {
    name: "logistic.transferout_invunit",
    path: "transferout_invunit-list",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferout_invunit.vue"
      ),
    secured: true,
    text: "Transfer OUT Inventory Unit List",
  },
  {
    name: "logistic.transferout_invunitform",
    path: "transferout_invunit-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferout_invunit_form.vue"
      ),
    secured: true,
    text: "transfer OUT Inventory Unit Form",
  },

  {
    name: "logistic.issuedgroup",
    path: "issued-group",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued_group.vue"
      ),
    secured: true,
    text: "Inventory Issued List",
  },
  {
    name: "logistic.issuedretur",
    path: "retur-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued_retur.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.stockopname",
    path: "stock-opname",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/stockopname.vue"
      ),
    secured: true,
    text: "Inventory Issued Form No Quanity",
  },
  {
    name: "logistic.stockopnamefrm",
    path: "stock-opname-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/stockopnamefrm.vue"
      ),
    secured: true,
    text: "Inventory Issued Form No Quanity",
  },
  {
    name: "logistic.transferin",
    path: "transfer-in",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transfer_in.vue"
      ),
    secured: true,
    text: "Inventory Issued List",
  },
  {
    name: "logistic.transferinfrm",
    path: "transfer-in-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferinfrm.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.transferinost",
    path: "tranfser-not-received",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/issued_form.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.transferout",
    path: "transfer-out",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferout.vue"
      ),
    secured: true,
    text: "Inventory Issued List",
  },
  {
    name: "logistic.transferoutfrm",
    path: "transfer-out-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/transferoutfrm.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.trading",
    path: "trading",
    component: () =>
      import(/* webpackChunkName: "logistic" */ "./views/logistic/trading.vue"),
    secured: true,
    text: "Trading",
  },
  {
    name: "logistic.tradingform",
    path: "trading-form",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/tradingfrm.vue"
      ),
    secured: true,
    text: "Trading Form",
  },
  {
    name: "logistic.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  //report
  {
    name: "logistic.rekoninvdb",
    path: "reconcile-inv-db",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rekoninvdb.vue"
      ),
    secured: true,
    text: "Reconcile Inventory Debet",
  },
  {
    name: "logistic.rekoninvcr",
    path: "reconcile-inv-cr",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rekoninvkr.vue"
      ),
    secured: true,
    text: "Reconcile Inventory Credit",
  },
  {
    name: "logistic.rptbalance",
    path: "report-inventory-balance",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rpt_balance.vue"
      ),
    secured: true,
    text: "Inventory Issued List",
  },
  {
    name: "logistic.rptcard",
    path: "report-inventory-card",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rpt_card.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.rptexpired",
    path: "report-inventory-expired",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rpt_expired.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },
  {
    name: "logistic.rptreorder",
    path: "inventory-need-reorder",
    component: () =>
      import(
        /* webpackChunkName: "logistic" */ "./views/logistic/rpt_reorder.vue"
      ),
    secured: true,
    text: "Inventory Issued Form",
  },

  {
    name: "payable",
    path: "/payable",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "payable/home",
    text: "Account Payable",
  },
  {
    name: "payable.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "payable.apaging",
    path: "ap-aging",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/apagingsubmodul.vue"
      ),
    secured: true,
    text: "Ap Aging",
  },
  {
    name: "payable.apagingaccounting",
    path: "ap-aging-accounting",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apaging.vue"),
    secured: true,
    text: "Ap Aging",
  },
  {
    name: "payable.apinv",
    path: "ap-invoice-list",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apinvlist.vue"),
    secured: true,
    text: "List of Account Payable",
  },
  {
    name: "payable.apinvfrm",
    path: "ap-invoice-form",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apinvfrm.vue"),
    secured: true,
    text: "AP Invoice Form",
  },
  {
    name: "payable.apinvfrmvoid",
    path: "ap-invoice-void-form",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/apinvfrmvoid.vue"
      ),
    secured: true,
    text: "AP Invoice VOID Form",
  },
  {
    name: "payable.apkontrak",
    path: "ap-contract",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apkontrak.vue"),
    secured: true,
    text: "List of AP Contract / UnBilled",
  },
  {
    name: "payable.apkontrakfrm",
    path: "ap-contract-frm",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/apkontrak-frm.vue"
      ),
    secured: true,
    text: "AP Contract / UnBilled Form",
  },

  {
    name: "payable.appostgrp",
    path: "ap-posting-group",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/appostgrp.vue"),
    secured: true,
    text: "List of Account Payable",
  },
  {
    name: "payable.apreval",
    path: "revaluation-ap-fcy",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apreval.vue"),
    secured: true,
    text: "Revaluation AP Foreign Currency",
  },
  {
    name: "payable.apsummary",
    path: "ap-summary",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/apsummary.vue"),
    secured: true,
    text: "Ap Summary",
  },
  {
    name: "payable.invadjust",
    path: "ap-adjustment",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/invadjust.vue"),
    secured: true,
    text: "AP Invoice Adjustment",
  },
  {
    name: "payable.invadjustfrm",
    path: "ap-adjustment-form",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/invadjustfrm.vue"
      ),
    secured: true,
    text: "AP Invoice Adjustment Form",
  },
  {
    name: "payable.pph",
    path: "pasal-pph",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/pph.vue"),
    secured: true,
    text: "Pasal PPh (With Holding Tox)",
  },
  {
    name: "payable.pphhutang",
    path: "wh-tax-payable",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/pphhutang.vue"),
    secured: true,
    text: "Hutang PPh (W/H Tax Payable)",
  },
  {
    name: "payable.ppnmasukan",
    path: "vat-in",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/ppnmasukan.vue"
      ),
    secured: true,
    text: "List VAT In(PPN Masukan)",
  },
  {
    name: "payable.rekonapdb",
    path: "reconcile-ap-settlement",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/rekonapdb.vue"),
    secured: true,
    text: "Reconcile AP Settlements",
  },
  {
    name: "payable.rekonapkr",
    path: "reconcile-ap",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/rekonapkr.vue"),
    secured: true,
    text: "Reconcile Account Payable",
  },
  {
    name: "payable.rekondpinvdb",
    path: "reconcile-dpinv-debit",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/rekondpdb.vue"),
    secured: true,
    text: "Reconcile DP Invoice DB",
  },
  {
    name: "payable.rekondpinvkr",
    path: "reconcile-dpinv-credit",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/rekondpkr.vue"),
    secured: true,
    text: "Reconcile DP Invoice CR",
  },
  {
    name: "payable.dpinvsmry",
    path: "dpinv-balance",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/rptdpsmry.vue"),
    secured: true,
    text: "Reconcile DP Invoice CR",
  },

  {
    name: "payable.trxvendor",
    path: "trx-vendor",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/trxvendor.vue"),
    secured: true,
    text: "Vendor Transaction History",
  },
  {
    name: "payable.vendor",
    path: "vendor-supplier",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/vendor.vue"),
    secured: true,
    text: "Vendor/Supplier List",
  },
  {
    name: "payable.vendorfrm",
    path: "vendor-supplier-form",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/payable/vendorfrm.vue"),
    secured: true,
    text: "Vendor/Supplier Form",
  },
  {
    name: "payable.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "payable" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  {
    name: "payable.perintahbayar",
    path: "perintah-bayar",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/perintahbayar.vue"
      ),
    text: "Edit Journal Voucher",
  },
  {
    name: "payable.apdpsettle",
    path: "ap-dp-settlement",
    component: () =>
      import(
        /* webpackChunkName: "payable" */ "./views/payable/apdpsettle.vue"
      ),
    secured: true,
    text: "List of AP vs DP Invoice Settlement",
  },

  {
    name: "procurement",
    path: "/procurement",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "procurement/home",
    text: "Procurement",
  },
  {
    name: "procurement.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  // master data
  {
    name: "procurement.invoiceterm",
    path: "invoice-termin",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/invoiceterm.vue"
      ),
    secured: true,
    text: "List - Receiving Invoice with Term",
  },
  {
    name: "procurement.invoicetermfrm",
    path: "invoice-termin-form",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/invoicetermfrm.vue"
      ),
    secured: true,
    text: "Form - Receiving Invoice with Term ",
  },
  {
    name: "procurement.item",
    path: "master-item-list",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/item.vue"
      ),
    secured: true,
    text: "List - Master Item",
  },
  {
    name: "procurement.itemfrm",
    path: "master-item-form",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemfrm.vue"
      ),
    secured: true,
    text: "Form - Master Item ",
  },
  {
    name: "procurement.itemcategory",
    path: "item-sub-category",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemcategory.vue"
      ),
    secured: true,
    text: "Post Sub Category - Master Item",
  },
  {
    name: "procurement.itemcategoryhead",
    path: "item-category",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemcategoryhead.vue"
      ),
    secured: true,
    text: "Post Category - Master Item",
  },
  {
    name: "procurement.itemgroup",
    path: "item-grouping",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/itemgroup.vue"
      ),
    secured: true,
    text: "Item Grouping",
  },
  {
    name: "procurement.vendor",
    path: "vendor-supplier",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/payable/vendor.vue"
      ),
    secured: true,
    text: "Vendor/Supplier List",
  },
  {
    name: "procurement.vendorfrm",
    path: "vendor-supplier-form/:vendor_id?",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/payable/vendorfrm.vue"
      ),
    secured: true,
    text: "Vendor/Supplier Form",
  },
  //transaction
  {
    name: "procurement.polist",
    path: "order-list",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/polist.vue"
      ),
    secured: true,
    text: "Purchase/Service Order List",
  },
  {
    name: "procurement.poinput",
    path: "order-form",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/poform.vue"
      ),
    secured: true,
    text: "Purchase/Service Order Form",
  },
  {
    name: "procurement.prstatushist",
    path: "pr-history-status",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/prstatushist.vue"
      ),
    secured: true,
    text: "PR History Status",
  },
  {
    name: "procurement.tendering",
    path: "tendering",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/tendering.vue"
      ),
    secured: true,
    text: "List of Tendering/Canvasing Sheet",
  },
  {
    name: "procurement.tenderingfrm1",
    path: "tendering-step1of4",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/tenderingfrm1.vue"
      ),
    secured: true,
    text: "Tendering Step 1 of 4",
  },
  {
    name: "procurement.tenderingfrm2",
    path: "tendering-step2of4",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/tenderingfrm2.vue"
      ),
    secured: true,
    text: "Tendering Step 2 of 4",
  },
  {
    name: "procurement.tenderingfrm3",
    path: "tendering-step3of4",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/tenderingfrm3.vue"
      ),
    secured: true,
    text: "Tendering Step 3 of 4",
  },
  {
    name: "procurement.tenderingfrm4",
    path: "tendering-step4of4",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/tenderingfrm4.vue"
      ),
    secured: true,
    text: "Tendering Step 4 of 4",
  },
  {
    name: "procurement.receiving",
    path: "receiving",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/receiving.vue"
      ),
    secured: true,
    text: "Receiving List",
  },
  {
    name: "procurement.receivingfrm",
    path: "receiving-form",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/receivingfrm.vue"
      ),
    secured: true,
    text: "Receiving Form",
  },
  // { name: "procurement.receivingposting", path: "po-receiving-posting", component: () => import(/* webpackChunkName: "procurement" */ './views/procurement/receivingapinvfrm.vue'), secured: true, text: "Receiving Form" },
  {
    name: "procurement.requisition",
    path: "requisition",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/pr_open.vue"
      ),
    secured: true,
    text: "Requisition List",
  },
  //report
  {
    name: "procurement.poinvpaym",
    path: "po-inv-paym-history",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/poinvpaym.vue"
      ),
    secured: true,
    text: "PO, Invoice , Payment Status",
  },
  {
    name: "procurement.poinvpaymbyponumber",
    path: "inv-paym-history-by-po",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/poinvpaymbypo.vue"
      ),
    secured: true,
    text: "Payment History BY PO",
  },
  {
    name: "procurement.hargaterakhir",
    path: "po-list-price",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/polistprice.vue"
      ),
    secured: true,
    text: "Purchase/Service Order List",
  },
  {
    name: "procurement.hargaquotation",
    path: "quotation-list-price",
    component: () =>
      import(
        /* webpackChunkName: "procurement" */ "./views/procurement/quotationprice.vue"
      ),
    secured: true,
    text: "Purchase/Service Order List",
  },

  {
    name: "receivable",
    path: "/receivable",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "receivable/home",
    text: "Account Receivable",
  },
  {
    name: "receivable.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  // master data
  {
    name: "receivable.customerfrm",
    path: "customer-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/customerfrm.vue"
      ),
    secured: true,
    text: "Customer Form",
  },
  {
    name: "receivable.customer",
    path: "customer",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/customer.vue"
      ),
    secured: true,
    text: "List of Customer",
  },
  {
    name: "receivable.salesae",
    path: "sales-executive",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/sales/salesaexec.vue"
      ),
    secured: true,
    text: "List of Sales Person",
  },
  {
    name: "receivable.arinvfrm",
    path: "ar-invoice-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvfrm.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.arinvfrmdisabled",
    path: "ar-invoice-form-disabled",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvfrm-disabled.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "sales.billingcommit",
    path: "billing-commitment",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/billingcommit.vue"),
    secured: true,
    text: "Billing Commitment ",
  },
  {
    name: "sales.billingcommitfrm",
    path: "billing-commitment-form",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/billingcommitfrm.vue"
      ),
    secured: true,
    text: "Billing Commitment Form",
  },
  {
    name: "receivable.customergroup",
    path: "customer-group",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/customergroup.vue"
      ),
    secured: true,
    text: "List of Customer",
  },

  {
    name: "receivable.arpostgrp",
    path: "ar-posting-group",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/argroup.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.invadjustgroup",
    path: "invoice-adjustment-group",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/invadjustgroup.vue"
      ),
    secured: true,
    text: "AR Invoice Adjustment",
  },
  {
    name: "receivable.potongan",
    path: "potongan-pada-ar",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/potongan.vue"
      ),
    secured: true,
    text: "Deduction/With Holding (Potongan)",
  },
  {
    name: "receivable.pph",
    path: "pasal-pph",
    component: () =>
      import(/* webpackChunkName: "receivable" */ "./views/payable/pph.vue"),
    secured: true,
    text: "Pasal PPh (With Holding Tax)",
  },
  {
    name: "receivable.salespostgrp",
    path: "sales-posting-group",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/salespostgrp.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.collector",
    path: "collector",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/collector.vue"
      ),
    secured: true,
    text: "Item List",
  },
  {
    name: "receivable.revenuechannel",
    path: "revenue-channel",
    component: () =>
      import(
        /* webpackChunkName: "channeltrx" */ "./views/receivable/revenuechannel.vue"
      ),
    secured: true,
    text: "Revenue Channel",
  },
  //transaction
  {
    name: "receivable.customerorder",
    path: "customer-order",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesorder.vue"),
    secured: true,
    text: "Customer Order",
  },
  {
    name: "receivable.arinv",
    path: "ar-invoice-list",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvlist.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.arinvpayview",
    path: "ar-invoice-payment-history",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvpayview.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.arinvview",
    path: "ar-invoice-view",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvview.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.aroststatus",
    path: "ar-outstanding-status",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/aroststatus.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "receivable.arpaymlist",
    path: "payment-settlement",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arpaymlist.vue"
      ),
    secured: true,
    text: "List of AR Payment - Collection Settlement ",
  },
  {
    name: "receivable.arpaymfrm",
    path: "payment-settlement-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arpaymfrm.vue"
      ),
    secured: true,
    text: "AR Payment Settlement - Form ",
  },
  {
    name: "receivable.arpaymwithlines",
    path: "payment-settlement-with-lines",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arpaymlist_withlines.vue"
      ),
    secured: true,
    text: "List of AR Payment - Collection Settlement ",
  },
  {
    name: "receivable.invadjust",
    path: "invoice-adjustment-list",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/invadjust.vue"
      ),
    secured: true,
    text: "AR Invoice Adjustment",
  },
  {
    name: "receivable.invadjustfrm",
    path: "invoice-adjustment-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/invadjustfrm.vue"
      ),
    secured: true,
    text: "AR Invoice Adjustment Form",
  },
  {
    name: "receivable.arinvrevision",
    path: "revision-void-invoice",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvrevision.vue"
      ),
    secured: true,
    text: "AR Invoice Revision",
  },
  {
    name: "receivable.arinvrevisionfrm",
    path: "revision-void-invoice-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvrevisionfrm.vue"
      ),
    secured: true,
    text: "AR Invoice Revision Form",
  },
  {
    name: "receivable.arinvrealisasi",
    path: "realisasi-invoice-unearned",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvrealisasi.vue"
      ),
    secured: true,
    text: "AR Invoice Revision",
  },
  {
    name: "receivable.arinvrealisasifrm",
    path: "realisasi-invoice-unearned-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvrealisasifrm.vue"
      ),
    secured: true,
    text: "AR Invoice Revision Form",
  },
  {
    name: "receivable.pbbsettle",
    path: "pbb-settle",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbbsettle.vue"
      ),
    secured: true,
    text: "List of UnEarned Income(PBB) Settlement ",
  },
  {
    name: "receivable.pbbsettlefrm",
    path: "pbb-settle-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbbsettlefrm.vue"
      ),
    secured: true,
    text: "UnEarned Income(PBB) Settlement - Form ",
  },
  {
    name: "receivable.targetcollection",
    path: "target-collection",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/targetcollection.vue"
      ),
    secured: true,
    text: "Target Collection ",
  },
  {
    name: "receivable.targetcollectionfrm",
    path: "target-collection-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/targetcollectionfrm.vue"
      ),
    secured: true,
    text: "Target Collection Form",
  },
  {
    name: "receivable.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "receivable" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  {
    name: "receivable.pbbadjust",
    path: "pbb-adjust",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbbadjust.vue"
      ),
    secured: true,
    text: "List of UnEarned Income(PBB) Settlement ",
  },
  {
    name: "receivable.pbbadjustfrm",
    path: "pbb-adjust-form",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbbadjustfrm.vue"
      ),
    secured: true,
    text: "UnEarned Income(PBB) Settlement - Form ",
  },

  // report
  {
    name: "receivable.araging",
    path: "ar-aging",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/araging.vue"
      ),
    secured: true,
    text: "AR Aging",
  },
  {
    name: "receivable.agingrekapcust",
    path: "ar-customer-summary",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/agingrekapcust.vue"
      ),
    secured: true,
    text: "AR Aging Customer Summary",
  },
  {
    name: "receivable.aragingnonefektif",
    path: "ar-aging-collector",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/aragingkolektor.vue"
      ),
    secured: true,
    text: "AR Aging (versi Collector)",
  },
  {
    name: "receivable.agingnonefektifrekapcust",
    path: "ar-collector-customer-summary",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/agingkolektorrekapcust.vue"
      ),
    secured: true,
    text: "AR Aging (versi Collector) Customer Summary",
  },
  {
    name: "receivable.aragingselisih",
    path: "ar-aging-selisih",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/aragingselisih.vue"
      ),
    secured: true,
    text: "AR Aging (versi Collector)",
  },
  {
    name: "receivable.arreval",
    path: "revaluation-ar-fcy",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arreval.vue"
      ),
    secured: true,
    text: "Revaluation AP Foreign Currency",
  },
  {
    name: "receivable.billing",
    path: "billing",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/arinvbilling.vue"
      ),
    secured: true,
    text: "AR Invoice (Customer Bill)",
  },
  {
    name: "receivable.trxcustomer",
    path: "trx-customer",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/trxcustomer.vue"
      ),
    secured: true,
    text: "Customer Transaction History",
  },
  {
    name: "receivable.pphprepaid",
    path: "wh-tax-prepaid",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pphprepaid.vue"
      ),
    secured: true,
    text: "PPh dipungut (W/H Tax by Customer)",
  },
  {
    name: "receivable.ppnkeluaran",
    path: "vat-out",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/ppnkeluaran.vue"
      ),
    secured: true,
    text: "List VAT In(PPN Masukan)",
  },
  {
    name: "receivable.pbbsmry",
    path: "pbb-balance",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbbsmry.vue"
      ),
    secured: true,
    text: "Unearn Income(PBB) Balance/Summary",
  },
  {
    name: "receivable.pbblist",
    path: "pbb-list",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/pbblist.vue"
      ),
    secured: true,
    text: "Unearn Income(PBB) Balance/Summary",
  },
  {
    name: "receivable.unearnedbalance",
    path: "unearned-balance",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/unearnedbalance.vue"
      ),
    secured: true,
    text: "Unearn Income(PBB) Balance/Summary",
  },
  {
    name: "receivable.unearnedsmry",
    path: "unearned-summary",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/unearnedsmry.vue"
      ),
    secured: true,
    text: "Unearn Income(PBB) Balance/Summary",
  },
  {
    name: "receivable.targetcollectionfull",
    path: "target-collection-progress",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/targetcollectionfull.vue"
      ),
  },
  {
    name: "receivable.targetcollectiondtl",
    path: "target-collection-realization",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/targetcollectiondtl.vue"
      ),
  },
  {
    name: "receivable.rptsales",
    path: "sales",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rptsales.vue"
      ),
    text: "Report Sales",
  },
  {
    name: "receivable.rptsales-unpaid",
    path: "sales-ar-unpaid",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rptsales_arunpaid.vue"
      ),
    text: "Report AR Sales (Sales of Unpaid AR)",
  },

  //rekon
  {
    name: "receivable.rekonardb",
    path: "reconcile-ar",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonardb.vue"
      ),
    secured: true,
    text: "Reconcile AP Settlements",
  },
  {
    name: "receivable.rekonarkr",
    path: "reconcile-ar-settlement",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonarkr.vue"
      ),
    secured: true,
    text: "Reconcile Account Receivable",
  },
  {
    name: "receivable.rekonunearnedkr",
    path: "reconcile-unearned-credit",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonunearnedkr.vue"
      ),
    secured: true,
    text: "Reconcile Deffered Income AP(Credit)",
  },
  {
    name: "receivable.rekonunearneddb",
    path: "reconcile-unearned-debit",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonunearneddb.vue"
      ),
    secured: true,
    text: "Reconcile Deffered Income AP(Debit)",
  },
  {
    name: "receivable.rekonsales",
    path: "reconcile-sales",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonsales.vue"
      ),
    secured: true,
    text: "Reconcile Sales/Revenue",
  },
  {
    name: "receivable.rekonpbbkr",
    path: "reconcile-pbb-credit",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonpbbkr.vue"
      ),
    secured: true,
    text: "Reconcile Unearned/PBB Income AP(Credit)",
  },
  {
    name: "receivable.rekonpbbdb",
    path: "reconcile-pbb-debit",
    component: () =>
      import(
        /* webpackChunkName: "receivable" */ "./views/receivable/rekonpbbdb.vue"
      ),
    secured: true,
    text: "Reconcile Unearned/PBB Income AP(Debit)",
  },

  {
    name: "sales",
    path: "/sales",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "sales/home",
    text: "Sales",
  },
  {
    name: "sales.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  // master data
  {
    name: "sales.customerfrm",
    path: "customer-form",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/receivable/customerfrm.vue"
      ),
    secured: true,
    text: "Customer Form",
  },
  {
    name: "sales.customer",
    path: "customer",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/receivable/customer.vue"),
    secured: true,
    text: "List of Customer",
  },
  {
    name: "sales.salesae",
    path: "sales-executive",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesaexec.vue"),
    secured: true,
    text: "List of Sales Person",
  },
  {
    name: "sales.customerorder",
    path: "customer-order",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesorder.vue"),
    secured: true,
    text: "Customer Order",
  },
  {
    name: "sales.customerorderbyae",
    path: "customer-order-byae/:byae?",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesorder.vue"),
    secured: true,
    text: "Customer Order",
  },
  {
    name: "sales.customerorderfrm",
    path: "customer-order-form",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesorderfrm.vue"),
    secured: true,
    text: "Customer Order",
  },
  {
    name: "sales.revisionorder",
    path: "revision-order",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesrevorder.vue"),
    secured: true,
    text: "Customer Order",
  },
  {
    name: "sales.revisionorderbyae",
    path: "revision-order-byae/:byae?",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesrevorder.vue"),
    secured: true,
    text: "Revision Order",
  },
  {
    name: "sales.revisionorderfrm",
    path: "revision-order-form",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/salesrevorderfrm.vue"
      ),
    secured: true,
    text: "Revision  Order",
  },
  {
    name: "sales.tdpcontactrpt",
    path: "tdp-cr",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/tdpcontactrpt.vue"),
    secured: true,
    text: "TDP Contact Report(Silent Disc.) ",
  },
  {
    name: "sales.tdpcontactrptae",
    path: "tdp-cr-byae/:byae?",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/tdpcontactrpt.vue"),
    secured: true,
    text: "TDP Contact Report(Silent Disc.) ",
  },
  {
    name: "sales.tdpcontactrptfrm",
    path: "tdp-cr-form",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/tdpcontactrptfrm.vue"
      ),
    secured: true,
    text: "TDP Contact form ",
  },
  {
    name: "sales.tdprequest",
    path: "tdp-request",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/tdprequest.vue"),
    secured: true,
    text: "TDP Contact Report(Silent Disc.) ",
  },
  {
    name: "sales.tdprequestae",
    path: "tdp-request-byae/:byae?",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/tdprequest.vue"),
    secured: true,
    text: "TDP Contact Report(Silent Disc.) ",
  },
  {
    name: "sales.tdprequestfrm",
    path: "tdp-request-form",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/tdprequestfrm.vue"),
    secured: true,
    text: "TDP Contact form ",
  },
  {
    name: "sales.rptsales",
    path: "sales-by-ae/:salesaename?/:salesaeid?/:tgl1?/:tgl2?",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/rptsalesbyae.vue"),
  },

  {
    name: "sales.customergroup",
    path: "customer-group",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/receivable/customergroup.vue"
      ),
    secured: true,
    text: "List of Customer",
  },

  {
    name: "sales.salesaeteam",
    path: "my-sales-team",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/salesaeteam.vue"),
    secured: true,
    text: "My Sales Team",
  },
  {
    name: "sales.salesitem",
    path: "sales-item",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/receivable/salespostgrp.vue"
      ),
    secured: true,
    text: "List of Sales Item",
  },
  {
    name: "sales.brand",
    path: "advertiser-brand",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/mstradvbrand.vue"),
    secured: true,
    text: "List of Brand - Advertiser Product",
  },
  {
    name: "sales.category",
    path: "advertiser-category",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/mstradvcategory.vue"
      ),
    secured: true,
    text: "List of Category - Advertiser Product",
  },
  //transaction
  {
    name: "sales.targetsales",
    path: "target-sales",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/targetsales.vue"),
    secured: true,
    text: "Target Sales",
  },
  {
    name: "sales.targetsalesfrm",
    path: "target-sales-form",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/targetsalesfrm.vue"
      ),
    secured: true,
    text: "Target Sales Form",
  },

  {
    name: "sales.campaign",
    path: "campaign",
    component: () =>
      import(/* webpackChunkName: "sales" */ "./views/sales/campaign.vue"),
    secured: true,
    text: "Campaign",
  },

  // { name: "sales.customerorder", path: "customer-order", component: () => import(/* webpackChunkName: "sales" */ './views/sales/customerorder.vue'), secured: true, text: "Customer Order" },
  // { name: "sales.customerorderfrm", path: "customer-order-form", component: () => import(/* webpackChunkName: "sales" */ './views/sales/customerorderfrm.vue'), secured: true, text: "Customer Order" },
  // { name: "sales.packagecommitfrm", path: "package-commitment-form", component: () => import(/* webpackChunkName: "sales" */ './views/sales/customercommitpackagefrm.vue'), secured: true, text: "Package Commit Form" },
  // { name: "sales.packagecommit", path: "package-commitment", component: () => import(/* webpackChunkName: "sales" */ './views/sales/customercommitpackage.vue'), secured: true, text: "Package Commit" },

  // report
  {
    name: "sales.progresssalesordered",
    path: "progress-sales-ordered",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/progresssalesordered.vue"
      ),
  },
  {
    name: "sales.progresssalesdelivered",
    path: "progress-sales-delivered",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/targetsalesfull.vue"
      ),
  },
  // { name: "sales.billingcommitprog", path: "billing-commitmen-progress", component: () => import(/* webpackChunkName: "sales" */ './views/sales/billingcommitprog.vue') },
  // { name: "sales.targetsalesdtl", path: "detail-sales-realization", component: () => import(/* webpackChunkName: "sales" */ './views/sales/targetsalesdtl.vue') },
  {
    name: "sales.salesbycustomer",
    path: "sales-by-customer/:cust_info?/:customer_id?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/customersalesdelivered.vue"
      ),
    secured: true,
    text: "Customer - Sales Delivered ",
  },
  {
    name: "sales.rptsalesgroup",
    path: "sales-by-ae-group",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/rptsalesbyaegroup.vue"
      ),
  },

  {
    name: "sales.salesorderbycustomer",
    path: "sales-order-by-customer/:cust_info?/:customer_id?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/customersalesorder.vue"
      ),
    secured: true,
    text: "Customer - Sales Order",
  },
  {
    name: "sales.complimentbycustomer",
    path: "compliment-by-customer/:cust_info?/:customer_id?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/customercompliment.vue"
      ),
    secured: true,
    text: "Customer - Compliment",
  },
  {
    name: "sales.salesdiscountbycustomer",
    path: "sales-discount-by-customer/:cust_info?/:customer_id?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/customerdiscount.vue"
      ),
    secured: true,
    text: "Customer - Discount",
  },
  {
    name: "sales.savingratebycustomer",
    path: "savingrate-by-customer/:cust_info?/:customer_id?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/customersavingrate.vue"
      ),
    secured: true,
    text: "Customer - Saving Rate ",
  },

  {
    name: "sales.topsalesbycustomer",
    path: "top-sales-by-customer",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/topsalesbycustomer.vue"
      ),
    secured: true,
    text: "Top Sales Order By Customer ",
  },
  {
    name: "sales.topsalesbyagency",
    path: "top-sales-by-agency",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/topsalesbycustomer.vue"
      ),
    secured: true,
    text: "Top Sales Order By Agency ",
  },
  {
    name: "sales.topsalesbyadvertiser",
    path: "top-sales-by-advertiser",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/topsalesbycustomer.vue"
      ),
    secured: true,
    text: "Top Sales Order By Advertiser ",
  },
  {
    name: "sales.salesorderbycampaign",
    path: "sales-order-by-campaign",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/salesorderbycampaign.vue"
      ),
    secured: true,
    text: "Sales Order by Campaign",
  },
  {
    name: "sales.salesbycategory",
    path: "sales-by-category",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/salesorderbycategory.vue"
      ),
    secured: true,
    text: "Sales Order by Category",
  },
  {
    name: "sales.salesbybrand",
    path: "sales-by-brand",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/salesorderbybrand.vue"
      ),
    secured: true,
    text: "Sales Order by Brand",
  },
  {
    name: "sales.salesbyproduct",
    path: "sales-by-product",
    component: () =>
      import(
        /* webpackChunkName: "sales" */ "./views/sales/salesorderbyproduct.vue"
      ),
    secured: true,
    text: "Sales Order by Product",
  },

  {
    name: "taxadmin",
    path: "/taxadmin",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "taxadmin/home",
    text: "Tax Administrator",
  },
  {
    name: "taxadmin.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "taxadmin.apinv",
    path: "ap-invoice",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/payable/apinvlisttax.vue"
      ),
    secured: true,
    text: "List of Account Payable",
  },
  {
    name: "taxadmin.aptaxadjust",
    path: "ap-tax-adjust",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/payable/tax-adjust.vue"
      ),
    secured: true,
    text: "List of AP TAX Correction",
  },
  {
    name: "taxadmin.aptaxadjustfrm",
    path: "ap-tax-adjust-form",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/payable/tax-adjustfrm.vue"
      ),
    secured: true,
    text: "AP TAX Correction Form",
  },
  {
    name: "taxadmin.arinv",
    path: "ar-invoice",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/receivable/arinvlist.vue"
      ),
    secured: true,
    text: "List of Account Receivable",
  },
  {
    name: "taxadmin.gl",
    path: "acc-general-ledger",
    component: () =>
      import(/* webpackChunkName: "taxadmin" */ "./views/accounting/gl.vue"),
    secured: true,
    text: "General Ledger",
  },
  {
    name: "taxadmin.pasalpph",
    path: "pasal-pph",
    component: () =>
      import(/* webpackChunkName: "taxadmin" */ "./views/payable/pph.vue"),
    secured: true,
    text: "Pasal PPh (With Holding Tox)",
  },
  {
    name: "taxadmin.pphpasiva",
    path: "wh-tax-payable",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/payable/pphhutang.vue"
      ),
    secured: true,
    text: "Hutang PPh (W/H Tax Payable)",
  },
  {
    name: "taxadmin.ppnmasukan",
    path: "vat-in",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/payable/ppnmasukan.vue"
      ),
    secured: true,
    text: "List VAT In(PPN Masukan)",
  },
  {
    name: "taxadmin.pphaktiva",
    path: "wh-tax-prepaid",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/receivable/pphprepaid.vue"
      ),
    secured: true,
    text: "PPh dipungut (W/H Tax by Customer)",
  },
  {
    name: "taxadmin.ppnkeluaran",
    path: "vat-out",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/receivable/ppnkeluaran.vue"
      ),
    secured: true,
    text: "List VAT In(PPN Masukan)",
  },
  {
    name: "taxadmin.ppnkeluarnsfp",
    path: "nsfp",
    component: () =>
      import(
        /* webpackChunkName: "taxadmin" */ "./views/receivable/ppnkeluarnsfp.vue"
      ),
    secured: true,
    text: "List Nomor Seri Faktur Pajak",
  },

  {
    name: "treasury",
    path: "/treasury",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./containers/mc-submodul.vue"),
    redirect: "treasury/home",
    text: "Finance(Treasury)",
  },
  {
    name: "treasury.home",
    path: "home",
    component: () =>
      import(/* webpackChunkName: "submodul" */ "./views/home.vue"),
  },
  {
    name: "treasury.bankcashacc",
    path: "bank-cash-account",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/bankcashacc.vue"
      ),
    secured: true,
    text: "Bank/Cash Account",
  },
  {
    name: "treasury.bankcashuser",
    path: "bank-cash-user",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/bankcashaccuser.vue"
      ),
    secured: true,
    text: "Bank/Cash Acc. User",
  },
  {
    name: "treasury.groupacc",
    path: "group-account",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/groupacccf.vue"
      ),
    secured: true,
    text: "Group Acccount CF",
  },
  //transaction
  {
    name: "treasury.rop",
    path: "rop",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/rop.vue"),
    secured: true,
    text: "List - Request of Payment",
  },
  {
    name: "treasury.ropform",
    path: "rop-form/:id?",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/rop_form.vue"
      ),
    secured: true,
    text: "Form - Request of Payment",
  },
  {
    name: "treasury.trxlist",
    path: "trxlist",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/trxlist.vue"),
    secured: true,
    text: "Cash/Bank Transaction",
  },
  {
    name: "treasury.payment",
    path: "payment/:id?",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/payment.vue"),
    secured: true,
    text: "Cash/Bank Transaction",
  },
  {
    name: "treasury.paymentvoid",
    path: "void-payment/:id?",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/paymentvoid.vue"
      ),
    secured: true,
    text: "Cash/Bank Transaction",
  },
  {
    name: "treasury.receipt",
    path: "receipt/:id?",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/receipt.vue"),
    secured: true,
    text: "Cash/Bank Receipt",
  },
  {
    name: "treasury.receiptvoid",
    path: "void-receipt/:id?",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/receiptvoid.vue"
      ),
    secured: true,
    text: "Cash/Bank Receipt",
  },
  {
    name: "treasury.appaymplan",
    path: "ap-payment-plan",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/appaymplan.vue"
      ),
    secured: true,
    text: "AP Payment Plan",
  },
  {
    name: "treasury.appaymplanfrm",
    path: "ap-payment-plan-frm",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/appaymplanfrm.vue"
      ),
    secured: true,
    text: "AP Payment Plan Form",
  },
  {
    name: "treasury.bankreval",
    path: "revaluation-bankcash-fcy",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/bankreval.vue"
      ),
    secured: true,
    text: "Revaluation Bank/Cash Foreign Currency",
  },
  {
    name: "treasury.editjvfrm",
    path: "edit-journal-voucher",
    component: () =>
      import(/* webpackChunkName: "receivable" */ "./views/jurnalfrm.vue"),
    text: "Edit Journal Voucher",
  },
  //rekon
  {
    name: "treasury.rekondb",
    path: "reconcile-receipt",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/rekondb.vue"),
    secured: true,
    text: "Reconcile Trx. Cash/Bank Debit",
  },
  {
    name: "treasury.rekonkr",
    path: "reconcile-payment",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/rekonkr.vue"),
    secured: true,
    text: "Reconcile Trx. Cash/Bank Credit",
  },
  {
    name: "treasury.rekonbank",
    path: "reconcile-bank-statement",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/rekonbank.vue"
      ),
    secured: true,
    text: "Reconcile Bank Statement",
  },
  //report
  {
    name: "treasury.bankcashbook",
    path: "bank-cash-book",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/bankcashbook.vue"
      ),
    secured: true,
    text: "Bank/Cash Book",
  },
  {
    name: "treasury.bankcashbookdetail",
    path: "bank-cash-book-detail",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/bankcashbookdetail.vue"
      ),
    secured: true,
    text: "Bank/Cash Book Detail",
  },
  {
    name: "treasury.bankcashgl",
    path: "bank-cash-gl",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/glbankcash.vue"
      ),
    secured: true,
    text: "General Ledger - Bank/Cash Acc.",
  },
  {
    name: "treasury.glfp12m",
    path: "bank-cash-position",
    component: () =>
      import(/* webpackChunkName: "treasury" */ "./views/treasury/glfp12m.vue"),
    secured: true,
    text: "General Ledger - Bank/Cash Acc.",
  },
  {
    name: "treasury.cashflowacc",
    path: "cashflow-acc",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowacc.vue"
      ),
    secured: true,
    text: "Cashflow Account",
  },
  {
    name: "treasury.cashflowdaterange",
    path: "cashflow-date-range",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowdaterange.vue"
      ),
    secured: true,
    text: "Report Cash Flow",
  },
  {
    name: "treasury.cashflowdim10",
    path: "cashflow-dimension-all",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowdim10.vue"
      ),
    secured: true,
    text: "Cash Flow Dimension All(Best 10)",
  },
  // { name: "treasury.cashflowgl", path: "general-ledger/:kodeaw?/:tgl1?/:tgl2?", component: () => import(/* webpackChunkName: "treasury" */ './views/treasury/cashflowgl.vue'), secured: true, text: "General Ledger Cashflow" },
  {
    name: "treasury.cashflowgl",
    path: "general-ledger/:kodeaw?/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowtrx.vue"
      ),
    secured: true,
    text: "General Ledger Cashflow",
  },
  {
    name: "treasury.cashflowthn",
    path: "cashflow-yearly",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowthn.vue"
      ),
    secured: true,
    text: "Report Cash Flow - Yearly",
  },
  {
    name: "treasury.cashflowbln",
    path: "cashflow-monthly",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowbln.vue"
      ),
    secured: true,
    text: "Report Cash Flow - Monthly",
  },
  {
    name: "treasury.cashflowlayout",
    path: "cashflow-layout-lines",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cashflowlayout.vue"
      ),
    secured: true,
    text: "Define Cash Flow Layout Lines",
  },
  {
    name: "treasury.cfinvalid",
    path: "trx-cf-acc-invalid/:tgl1?/:tgl2?",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/cfinvalidacc.vue"
      ),
    secured: true,
    text: "Transaction with Invalid CF Acc.",
  },
  {
    name: "treasury.trxlistreport",
    path: "report-trxlist",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/trxlistreport.vue"
      ),
    secured: true,
    text: "Report Cash/Bank Transaction",
  },
  // { name: "treasury.apoutstand", path: "ap-outstanding", component: () => import(/* webpackChunkName: "treasury" */ './views/treasury/apoutstand.vue'), secured: true, text: "AP Outsanding - Vendor Summary" },
  {
    name: "treasury.apoutstand",
    path: "ap-outstanding",
    component: () =>
      import(
        /* webpackChunkName: "treasury" */ "./views/treasury/apoutstandgroup.vue"
      ),
    secured: true,
    text: "AP Outsanding - Vendor & AP Group Summary",
  },
];
function hasAccessMenu(routeName) {
  const appmenus = store.state.menuroute || [];
  // console.log(`appmenus: `, appmenus);
  if (appmenus.length > 0) {
    const ada = appmenus.find(r => r.route == routeName);
    // console.log(`routeName ${routeName}: `, ada);
    if (ada) {
      return true;
    }
    return false;
  } else {
    return true;
  }
}

routes.forEach((row) => {
  const length = row.name.split(".").length;
  const children = routes.filter(
    (m) =>
      m.name.split(".").length === length + 1 && m.name.indexOf(row.name) === 0
  );

  if (children.length > 0) row.children = children;

  const meta = row.meta || {};

  if (row.text) {
    meta.label = row.text;
  }
  row.meta = meta;

  if (row.secured) {
    row.beforeEnter = async function (to, from, next) {
      const { user } = store.state;
      if (user) {
        if (user.group) {
          if (row.name.indexOf("app") == -1) {
            if (
              from.name == "app.approvalfrm" &&
              (to.name == "budget.mstrbudgetprogress" ||
                to.name == "budget.annualbudgetprogress")
            ) {
              store.commit("prevRoute", from);
              next();
            } else if (
              from.name == "budget.annualbudget" &&
              to.name == "budget.annualbudgetcopy"
            ) {
              store.commit("prevRoute", from);
              next();
            } else if (
              from.name == "treasury.trxlist" &&
              to.name == "treasury.paymentvoid"
            ) {
              store.commit("prevRoute", from);
              next();
            } else if (
              from.name == "treasury.trxlist" &&
              to.name == "treasury.receiptvoid"
            ) {
              store.commit("prevRoute", from);
              next();
            } else if (to.name == "receivable.arinvfrmdisabled") {
              try {
                const access = await auth.access("receivable.arinvfrm");
                if (access.success == true) {
                  store.commit("prevRoute", from);
                  next();
                } else {
                  next({ name: "app.unauthorize" });
                }
              } catch (error) {
                // if ((error.name === "TokenExpiredError") && (error.message === "jwt expired")) {
                //     console.log('Routes this.$store: ', this.$store);
                //     this.$store.commit("redirectPath", 'receivable.arinvfrm');
                //     next({ name: 'page.login' });
                // }
                token.refresh();
                const access = await auth.access(to.name);
                if (access.success == true) {
                  store.commit("prevRoute", from);
                  next();
                } else {
                  next({ name: "app.unauthorize" });
                }
              }
            } else {
              try {
                if (hasAccessMenu(to.name)) {
                  const access = await auth.access(to.name);
                  if (access.success == true) {
                    store.commit("prevRoute", from);
                    next();
                  } else {
                    next({ name: "app.unauthorize" });
                  }
                } else {
                  next({ name: "app.unauthorize" });
                }
              } catch (error) {
                // if ((error.name === "TokenExpiredError") && (error.message === "jwt expired")) {
                //     console.log('Routes this.$store: ', this.$store);
                //     this.$store.commit("redirectPath", to.name);
                //     next({ name: 'page.login' });
                // }
                token.refresh();
                const access = await auth.access(to.name);
                if (access.success == true) {
                  store.commit("prevRoute", from);
                  next();
                } else {
                  next({ name: "app.unauthorize" });
                }
              }
            }
          } else {
            if (to !== from) {
              store.commit("prevRoute", from);
            }
            next();
          }
          return;
        }
      }
      // let loginfrom = window.location.href ;
      // console.log('loginfrom : ', loginfrom);
      // if  (loginfrom.includes("login"))  loginfrom='';
      // next({ name: 'page.login', query: { from: loginfrom } });
      next({ name: "page.login" });
    };
  } else {
    row.beforeEnter = function (to, from, next) {
      if (to !== from) {
        store.commit("prevRoute", from);
      }
      next();
    };
  }
});

export default {
  instance: async () => {
    const resp = new Router({
      base: process.env.BASE_URL,
      linkActiveClass: "open active",
      scrollBehavior: () => ({ y: 0 }),
      routes: routes.filter((row) => row.name.split(".").length == 1),
    });
    return resp;
  },
};
